import defaultMdxComponents from "fumadocs-ui/mdx";
import type { MDXComponents } from "mdx/types";
import type { ComponentProps } from "react";

import { Accordion } from "./accordion";
import { Card, CardGroup } from "./cards";
import { Info, Note, Tip, Warning } from "./callouts";
import { CodeGroup } from "./code-group";
import { Frame } from "./frame";
import { Metadata } from "./metadata";
import { Step, Steps } from "./steps";
import { Tab, Tabs } from "./tabs";

const DefaultLink = defaultMdxComponents.a;

function MdxLink({ href, ...props }: ComponentProps<"a">) {
  if (href?.startsWith("#")) {
    return <a href={href} {...props} />;
  }

  return <DefaultLink href={href} {...props} />;
}

export function getMDXComponents(components?: MDXComponents) {
  return {
    ...defaultMdxComponents,
    a: MdxLink,
    Accordion,
    Card,
    CardGroup,
    CodeGroup,
    Frame,
    Info,
    Metadata,
    Note,
    Step,
    Steps,
    Tab,
    Tabs,
    Tip,
    Warning,
    ...components,
  } satisfies MDXComponents;
}
